import React, { useState } from 'react';
import { Play } from 'lucide-react';
import { IMG, PRICE, Reveal, Overline } from './shared';
import { trackEvent } from '../../lib/analytics';

const FEATURES = ['15,000Pa', 'LiDAR + AI', 'Vacuum + Mop', '3L Self-Empty', 'HEPA', 'Up to 3,000 sq.ft.'];

export const BeautyShot = ({ onBuy }) => (
  <section className="bg-[#f5f5f7] text-gray-900 py-28 md:py-40 px-6 md:px-12 text-center" data-testid="hv2-beauty">
    <div className="max-w-5xl mx-auto">
      <Reveal>
        <img src={IMG.features} alt="Harpalyk SMARTBOT LumineX 300 robot vacuum and mop — feature overview" loading="lazy" decoding="async" className="w-full max-w-3xl mx-auto rounded-3xl shadow-xl" />
      </Reveal>
      <Reveal delay={100}>
        <h2 className="font-outfit text-5xl md:text-7xl font-medium tracking-tighter mt-14">LumineX 300</h2>
      </Reveal>
      <Reveal delay={200}>
        <p className="font-manrope text-sm md:text-base text-gray-500 mt-6 tracking-wide">
          {FEATURES.join('  ·  ')}
        </p>
      </Reveal>
      <Reveal delay={300}>
        <p className="font-oswald text-4xl md:text-5xl font-medium mt-8" data-testid="hv2-beauty-price">{PRICE}</p>
      </Reveal>
      <Reveal delay={400}>
        <div className="flex flex-wrap justify-center gap-4 mt-8">
          <button onClick={onBuy} data-testid="hv2-beauty-buy-btn" className="font-manrope bg-[#0057B8] hover:bg-[#004494] text-white px-8 py-4 rounded-full font-semibold transition-colors">
            BUY LUMINEX 300
          </button>
          <a href="#contact" onClick={() => trackEvent('homepage_luminex_demo')} data-testid="hv2-beauty-demo-btn" className="font-manrope border border-black/15 hover:bg-black hover:text-white px-8 py-4 rounded-full font-semibold transition-colors">
            BOOK A DEMO
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);

export const VideoMoment = () => {
  const [playing, setPlaying] = useState(false);
  const play = () => { setPlaying(true); trackEvent('homepage_luminex_video'); };
  return (
    <section className="bg-[#0a0a0a] text-white py-28 md:py-36 px-6 md:px-12" data-testid="hv2-video">
      <div className="max-w-6xl mx-auto">
        <Reveal className="text-center mb-12">
          <Overline dark>Product Film</Overline>
          <h2 className="font-outfit text-4xl md:text-6xl font-medium tracking-tighter">SEE HARPALYK ROBOTS IN ACTION</h2>
        </Reveal>
        <Reveal delay={150}>
          <div className="relative aspect-video w-full bg-[#141414] border border-white/10 overflow-hidden">
            {playing ? (
              <iframe
                src="https://www.youtube-nocookie.com/embed/NuXKvVsjE5g?autoplay=1"
                title="Luxury Living, Powered by AI | Harpalyk Intelligent Robots"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="absolute inset-0 w-full h-full"
              />
            ) : (
              <button onClick={play} data-testid="hv2-video-play-btn" className="group absolute inset-0 w-full h-full" aria-label="Play Harpalyk product film">
                <img src="https://img.youtube.com/vi/NuXKvVsjE5g/maxresdefault.jpg" alt="Harpalyk intelligent robots product film" loading="lazy" decoding="async" className="w-full h-full object-cover opacity-80" />
                <span className="absolute inset-0 flex items-center justify-center">
                  <span className="flex h-20 w-20 items-center justify-center rounded-full bg-white text-black group-hover:scale-110 transition-transform duration-300">
                    <Play size={28} className="ml-1" />
                  </span>
                </span>
              </button>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
